module.exports = __webpack_public_path__ + "img/Vector-photo.13163b65.png";